import React, { useEffect, useMemo, useState } from 'react'
import Draggable from 'react-draggable'
import { Box, Dialog, DialogContent, DialogTitle, Paper } from '@mui/material'
import { PaperProps } from '@mui/material'
import CrossDialogBtn from 'common/Button/CrossDialogBtn'
import { EditIconImg } from 'common/FaberComponents/icons/EditIcon'
import useModal from 'hooks/useModal'
import { SubscriptionsTableRows } from 'types/api/faber/subscription.type'

import UserBillingCycleForm from './UserBillingCycleForm'
import UserPlanForm from './UserPlanForm'
import UserProfileForm from './UserProfileForm'

export function PaperComponent(props: PaperProps) {
  return (
    <Draggable
      handle='#draggable-dialog-title'
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  )
}

export const BILLING_ACCOUNT_TITLE = 'Billing Cycle & Account Status'
export const PROFILE_TITLE = 'Profile'
export const PLAN_TITLE = 'Plan'
function UpdateFaberUserDetailsDialog({
  customerRow,
  fieldTitle,
  onSuccessfulFormSubmission,
  currentBillingDate,
  nextPlan,
  nextBillingDate
}: UserProps) {
  // dialog handlers
  const {
    openModal: handleDialogOpen,
    closeModal: handleDialogClose,
    isShowing: dialogOpen
  } = useModal()

  const [isEditButtonVisible, setIsEditButtonVisible] = useState(true)

  useEffect(() => {
    if (
      customerRow.planStatus === 'SUSPENDED' &&
      fieldTitle === BILLING_ACCOUNT_TITLE
    ) {
      setIsEditButtonVisible(false)
    }

    if (customerRow.planStatus === 'SUSPENDED' && fieldTitle === PLAN_TITLE) {
      setIsEditButtonVisible(false)
    }

    if (customerRow.planStatus === 'CANCELLED') {
      setIsEditButtonVisible(false)
    }

    if (customerRow.planStatus === 'EXPIRING' && fieldTitle === PLAN_TITLE) {
      setIsEditButtonVisible(false)
    }

    if (customerRow.planStatus === 'ACTIVE') {
      setIsEditButtonVisible(true)
    }
  }, [customerRow])

  const userFormComponents = useMemo(() => {
    return {
      Profile: (
        <UserProfileForm
          customerRow={customerRow}
          onSuccessfulFormSubmission={onSuccessfulFormSubmission}
          handleDialogClose={handleDialogClose}
        />
      ),
      'Billing Cycle & Account Status': (
        <UserBillingCycleForm
          customerRow={customerRow}
          onSuccessfulFormSubmission={onSuccessfulFormSubmission}
          handleDialogClose={handleDialogClose}
          currentBillingDate={currentBillingDate}
          nextBillingDate={nextBillingDate}
        />
      ),

      Plan: (
        <UserPlanForm
          customerRow={customerRow}
          onSuccessfulFormSubmission={onSuccessfulFormSubmission}
          nextPlan={nextPlan}
          handleDialogClose={handleDialogClose}
        />
      )
    }
  }, [customerRow])

  return (
    <>
      {isEditButtonVisible ? (
        <EditIconImg
          onEdit={handleDialogOpen}
          editName={
            fieldTitle === 'Billing Cycle & Account Status'
              ? 'Unsubscribe/Resubscribe'
              : undefined
          }
        />
      ) : null}
      <Dialog
        open={dialogOpen}
        maxWidth='sm'
        fullWidth={true}
        onClose={handleDialogClose}
        PaperComponent={PaperComponent}
        aria-labelledby='draggable-dialog-title'
      >
        <Box sx={{ py: 2, px: 0 }}>
          <DialogTitle
            sx={{
              margin: '0',
              fontWeight: '700',
              color: 'black',
              fontSize: '21px',
              mt: '4px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              px: 5
            }}
          >
            <Box>
              Edit{' '}
              {fieldTitle === 'Billing Cycle & Account Status'
                ? 'Account Status'
                : fieldTitle}
            </Box>
            <CrossDialogBtn dialogClose={handleDialogClose} />
          </DialogTitle>
          <DialogContent sx={{ padding: '0' }}>
            {userFormComponents[fieldTitle]}
          </DialogContent>
        </Box>
      </Dialog>
    </>
  )
}

export default UpdateFaberUserDetailsDialog

interface UserProps {
  customerRow: SubscriptionsTableRows
  fieldTitle: 'Profile' | 'Billing Cycle & Account Status' | 'Plan' | string
  onSuccessfulFormSubmission: () => void
  currentBillingDate?: string
  nextBillingDate?: string
  nextPlan: string | undefined
}

export interface UpdateObject {
  firstName: string
  lastName: string
  email: string
  nextPlan: string
  accStatus: string
  remarks: string
}
